import "./categories.css"
import { DataGrid } from "@material-ui/data-grid"
import { DeleteOutline } from "@material-ui/icons"
import { Link } from "react-router-dom"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getCategories, deleteCategory } from "../../redux/apiCalls"
import { useSelector } from "react-redux"

export default function Categories() {
  const dispatch = useDispatch()
  const categories = useSelector((state) => state.category.categories)

  useEffect(() => {
    getCategories(dispatch)
  }, [dispatch])

  const handleDelete = (id) => {
    deleteCategory(dispatch, id)
  }

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "category",
      headerName: "Category",
      width: 200,
      renderCell: (params) => {
        return (
          <div className='productListItem'>
            <img className='productListImg' src={params.row.image} alt='' />
            {params.row.name}
          </div>
        )
      },
    },
    { field: "description", headerName: "Description", width: 400 },

    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <Link to={"/category/" + params.row.id}>
              <button className='productListEdit'>Edit</button>
            </Link>
            <DeleteOutline
              className='productListDelete'
              onClick={() => handleDelete(params.row.id)}
            />
          </>
        )
      },
    },
  ]

  return (
    <div className='productList'>
      {categories && (
        <DataGrid
          rows={categories}
          disableSelectionOnClick
          columns={columns}
          pageSize={8}
          checkboxSelection
          disableColumnMenu={true}
        />
      )}
    </div>
  )
}
